import type { JsonQuestionnaireSection } from '@/components/questionnaires/json-driven/types';

export type QuestionnaireCardStatus = 'ready' | 'customized' | 'draft';

import { getActiveQuestionCount } from '@/components/questionnaires/json-driven/questionMetrics';

/** API section + tab type and status. Cards read templateQuestionsCount, estimatedTimeMinutes, etc. directly. */
export type QuestionnaireCardData = JsonQuestionnaireSection & {
  type: 'core' | 'custom';
  status: QuestionnaireCardStatus;
  /** Module from GET /questionnaires/conditional (not a user-authored custom draft). */
  isConditionalModule?: boolean;
};

/** Helpers for display values from API shape */
export function getCardQuestionCount(card: QuestionnaireCardData): number {
  const fromSection = getActiveQuestionCount(card);
  if (fromSection > 0) return fromSection;

  if (card.type === 'custom') {
    if (typeof card.questionsCount === 'number' && Number.isFinite(card.questionsCount)) {
      return card.questionsCount;
    }
    return typeof card.templateQuestionsCount === 'number' && Number.isFinite(card.templateQuestionsCount)
      ? card.templateQuestionsCount
      : 0;
  }
  if (typeof card.templateQuestionsCount === 'number' && Number.isFinite(card.templateQuestionsCount)) {
    return card.templateQuestionsCount;
  }
  return typeof card.questionsCount === 'number' && Number.isFinite(card.questionsCount)
    ? card.questionsCount
    : 0;
}

export function getCardEstimatedMinutes(card: QuestionnaireCardData): number {
  const v = card.estimatedTimeMinutes;
  return typeof v === 'number' && Number.isFinite(v) ? v : 0;
}

export function getCardTitle(card: QuestionnaireCardData): string {
  const t = card.title?.trim();
  const n = card.name?.trim();
  return t || n || 'Untitled Questionnaire';
}

export function getCardDescription(card: QuestionnaireCardData): string {
  return card.description ?? '';
}
